// removed by extract-text-webpack-plugin
module.exports = {"container":"_2z1oa","wrapper":"_3iCa0","listItemMobile":"_3EmXZ","pagination":"So-sr","separator":"_349Md"};


//////////////////
// WEBPACK FOOTER
// ./app/components/search-results-list/search-results-list.scss
// module id = 1331
// module chunks = 0